import React, { useReducer } from 'react';
import styles from './SignUp.module.scss';
import reducer from './signup-reducer';
import Constant from '../../constants';
import wondering from '../../images/wondering-big.svg';
import youcan from '../../images/you-can.svg';
import whitedot from '../../images/white-dot.svg';

const initialState = {};
const SignUp = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <main className={styles.signupContainer}>
      <article className={styles.continueContainer}>
        <section className={styles.whiteCard}>
          <img className={styles.wonderImg} src={wondering} />
        </section>
        <section className={styles.points}>
          {Constant.SIGNUP_DATA.alpha.map((item) => {
            return (
              <div key={item.id} className={styles.point}>
                <img src={whitedot} />
                <p>{item.msg}</p>
              </div>
            );
          })}
        </section>
        <section className={styles.continueBtn}>Continue as ALPHA</section>
      </article>
      <article className={styles.continueContainer}>
        <section className={styles.whiteCard}>
          <img className={styles.youcanImg} src={youcan} />
        </section>
        <section className={styles.points}>
          {Constant.SIGNUP_DATA.omega.map((item) => {
            return (
              <div key={item.id} className={styles.point}>
                <img src={whitedot} />
                <p>{item.msg}</p>
              </div>
            );
          })}
        </section>
        <section className={styles.continueBtn}>Continue as OMEGA</section>
      </article>
    </main>
  );
};

export default SignUp;
